import styled from '@emotion/styled';
import Button from '@/components/atoms/Button/Button';

export const StyledAssistantButton = styled(Button)`
  * {
    box-sizing: border-box;
  }

  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  padding: 5px 10px;
`;
